// Dora Deco — Shopify Theme JS
// Converted from the static site scripts.

(function () {
  'use strict';

  var body = document.body;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  body.classList.add('has-js');
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { body.classList.add('is-ready'); });
  });

  // Year
  document.querySelectorAll('.js-year').forEach(function (el) {
    el.textContent = String(new Date().getFullYear());
  });

  // Sticky header
  var header = document.querySelector('.site-head');
  function updateHeader() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 14);
  }
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  // Mobile menu
  var menuButton = document.querySelector('.menu-toggle');
  var menu = document.getElementById('primary-nav');
  function closeMenu() {
    if (!menuButton || !menu) return;
    menuButton.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-open');
    body.classList.remove('menu-open');
  }
  if (menuButton && menu) {
    menuButton.addEventListener('click', function () {
      var open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
      body.classList.toggle('menu-open', !open);
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 760) closeMenu();
    });
  }

  // Wordmark spin on touch
  if (!reduceMotion) {
    document.querySelectorAll('.wordmark').forEach(function (mark) {
      mark.addEventListener('touchstart', function () {
        mark.classList.add('is-spun');
        clearTimeout(mark._spinTimer);
        mark._spinTimer = setTimeout(function () {
          mark.classList.remove('is-spun');
        }, 1150);
      }, { passive: true });
    });
  }

  // Reveal-on-scroll
  var revealed = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || reduceMotion) {
    revealed.forEach(function (element) { element.classList.add('is-in'); });
  } else {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });
    revealed.forEach(function (element) { revealObserver.observe(element); });
  }

  // Hero video autoplay
  var video = document.getElementById('hero-video');
  var videoFrame = document.getElementById('video-frame');
  if (video && videoFrame && !reduceMotion) {
    video.addEventListener('canplay', function () {
      videoFrame.classList.add('is-video-ready');
    });
    video.play().catch(function () {});
  }

  // Hero 3D tilt
  if (!reduceMotion && videoFrame) {
    document.addEventListener('mousemove', function (e) {
      var rect = videoFrame.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var dx = (e.clientX - cx) / (window.innerWidth / 2);
      var dy = (e.clientY - cy) / (window.innerHeight / 2);
      videoFrame.style.setProperty('--tilt-x', (dy * -3).toFixed(2) + 'deg');
      videoFrame.style.setProperty('--tilt-y', (dx * 4).toFixed(2) + 'deg');
    });
  }


  // Dimensions SVG diagram (product pages)
  function renderDimsDiagram(container, dimRaw) {
    var isWidth = /^W /.test(dimRaw);
    var halves = dimRaw.split(' · H ');
    if (halves.length < 2) return;
    var size = parseFloat(halves[0].replace(/[^0-9.]/g, ''));
    var h    = parseFloat(halves[1].replace(/[^0-9.]/g, ''));
    if (isNaN(size) || isNaN(h)) return;

    function f(n) { return (+n).toFixed(1); }

    var cx = 170, yBase = 124;
    var halfSpan = Math.max(Math.min(size * 5.3, 100), 40);
    var hPx      = Math.max(Math.min(h * 9, 88), 12);
    var xl = cx - halfSpan, xr = cx + halfSpan;
    var yRim   = yBase - hPx;
    var yInner = yBase - Math.min(hPx * 0.15 + 4, 12);
    var cpOff  = halfSpan * 0.1;
    var cpY    = hPx * 0.4;

    var dPath = 'M' + xl + ' ' + yRim
      + ' C' + f(xl + cpOff) + ' ' + f(yRim + cpY)
      + ' ' + f(cx - halfSpan * 0.38) + ' ' + f(yInner)
      + ' ' + cx + ' ' + f(yInner)
      + ' C' + f(cx + halfSpan * 0.38) + ' ' + f(yInner)
      + ' ' + f(xr - cpOff) + ' ' + f(yRim + cpY)
      + ' ' + xr + ' ' + yRim;

    var yDL  = 26;
    var xH   = xr + 20;
    var sLbl = (isWidth ? 'W ' : '⌀ ') + size + ' cm';
    var hLbl = h + ' cm';

    var ns  = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 340 170');
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-hidden', 'true');

    function ln(x1, y1, x2, y2) {
      var el = document.createElementNS(ns, 'line');
      el.classList.add('dline');
      el.setAttribute('x1', x1); el.setAttribute('y1', y1);
      el.setAttribute('x2', x2); el.setAttribute('y2', y2);
      return el;
    }
    function tx(x, y, str, anc) {
      var el = document.createElementNS(ns, 'text');
      el.setAttribute('x', x); el.setAttribute('y', y);
      if (anc) el.setAttribute('text-anchor', anc);
      el.textContent = str;
      return el;
    }

    var pe = document.createElementNS(ns, 'path');
    pe.classList.add('dsil');
    pe.setAttribute('d', dPath);
    svg.appendChild(pe);

    svg.appendChild(ln(xl, yDL, xr, yDL));
    svg.appendChild(ln(xl, yDL - 4, xl, yDL + 4));
    svg.appendChild(ln(xr, yDL - 4, xr, yDL + 4));
    svg.appendChild(tx(cx, yDL - 10, sLbl, 'middle'));

    svg.appendChild(ln(xH, yRim, xH, yBase));
    svg.appendChild(ln(xH - 4, yRim, xH + 4, yRim));
    svg.appendChild(ln(xH - 4, yBase, xH + 4, yBase));
    svg.appendChild(tx(xH + 8, (yRim + yBase) / 2 + 4, hLbl));

    container.innerHTML = '';
    container.appendChild(svg);
  }

  document.querySelectorAll('.specs[data-dim-raw]').forEach(function (specs) {
    var raw  = specs.getAttribute('data-dim-raw');
    var diag = specs.querySelector('.specs-diagram');
    if (diag && raw) renderDimsDiagram(diag, raw);
  });

  // Product gallery lightbox (product pages)
  (function () {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var items = gallery.querySelectorAll('[data-gallery-item]');
    if (items.length === 0) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'gallery-lightbox' + (items.length === 1 ? ' is-single' : '');
    dialog.setAttribute('aria-label', window.DD_TEXT.galleryViewer);
    var currentIndex = 0;

    var imagesData = [];
    items.forEach(function (item, i) {
      var img = item.querySelector('img');
      imagesData.push({ src: item.href || img.src, alt: img ? img.alt : '' });
    });

    function showImage(index) {
      currentIndex = index;
      var data = imagesData[index];
      dialog.querySelector('.gallery-lightbox__image').src = data.src;
      dialog.querySelector('.gallery-lightbox__image').alt = data.alt;
      dialog.querySelector('.gallery-lightbox__count').textContent = (index + 1) + ' / ' + imagesData.length;
    }

    dialog.innerHTML = `
      <div class="gallery-lightbox__top">
        <span class="gallery-lightbox__count mono"></span>
        <button class="gallery-lightbox__close mono" type="button">${window.DD_TEXT.galleryClose}</button>
      </div>
      <div class="gallery-lightbox__stage">
        <div class="gallery-lightbox__figure">
          <img class="gallery-lightbox__image" src="" alt="">
        </div>
        <button class="gallery-lightbox__arrow gallery-lightbox__arrow--prev" aria-label="${window.DD_TEXT.galleryPrevious}" type="button">&#8592;</button>
        <button class="gallery-lightbox__arrow gallery-lightbox__arrow--next" aria-label="${window.DD_TEXT.galleryNext}" type="button">&#8594;</button>
      </div>
    `;
    document.body.appendChild(dialog);

    items.forEach(function (item, i) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        showImage(i);
        dialog.showModal();
      });
    });

    dialog.querySelector('.gallery-lightbox__close').addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('.gallery-lightbox__arrow--prev').addEventListener('click', function () {
      showImage((currentIndex - 1 + imagesData.length) % imagesData.length);
    });
    dialog.querySelector('.gallery-lightbox__arrow--next').addEventListener('click', function () {
      showImage((currentIndex + 1) % imagesData.length);
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    document.addEventListener('keydown', function (e) {
      if (!dialog.open) return;
      if (e.key === 'ArrowLeft') showImage((currentIndex - 1 + imagesData.length) % imagesData.length);
      if (e.key === 'ArrowRight') showImage((currentIndex + 1) % imagesData.length);
    });
  })();

})();

